import React from "react";
import PropTypes from "prop-types";
import DraggableList from "../../common/components/draggable/DraggableList";
import MatchSummary from "./MatchSummary";

const MatchSummaryList = ({
	matches,
	matchType,
	order = [],
	onChangeMatchesOrder
}) => {
	const items = matches
		.sort((a, b) => {
			if (order.indexOf(a.id) >= 0 && order.indexOf(b.id) >= 0) {
				return order.indexOf(a.id) - order.indexOf(b.id);
			}

			return -1;
		})
		.map((match) => {
			return { id: match.id, match };
		});

	return (
		<DraggableList
			listItems={items}
			targetType={matchType}
			ItemTemplate={MatchSummary}
			onChange={onChangeMatchesOrder}
		/>
	);
};

MatchSummaryList.defaultProps = {
	onChangeMatchesOrder: () => {}
};

MatchSummaryList.propTypes = {
	matches: PropTypes.array.isRequired,
	matchType: PropTypes.string.isRequired,
	order: PropTypes.array.isRequired,
	onChangeMatchesOrder: PropTypes.func
};

export default MatchSummaryList;
